module.exports = __webpack_public_path__ + "img/group3.978ac81b.svg";